import React from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./Background.css";
import video from "../../Assets/video1.mov";

const Background = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* ✅ SEO UPDATED */}
      <Helmet>
        <title>
          Explore & Drive Your Journey | Car Rental & Tours in Indore
        </title>

        <meta
          name="description"
          content="Experience luxury Tour Packages, reliable Self Drive Cars, and professional Taxi Services in Indore. Available 24×7."
        />

        {/* ✅ ADD CANONICAL */}
        <link rel="canonical" href="https://www.shreeramcarrental.com/" />

        {/* ✅ ADD SCHEMA */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "Shree Ram Car Rental",
            "url": "https://www.shreeramcarrental.com",
            "potentialAction": {
              "@type": "SearchAction",
              "target": "https://www.shreeramcarrental.com/search?q={search_term_string}",
              "query-input": "required name=search_term_string"
            }
          }
          `}
        </script>
      </Helmet>

      <section className="hero-container">
        
        {/* ✅ VIDEO */}
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          className="hero-video"
        >
          <source src={video} type="video/mp4" />
        </video>

        {/* ✅ OVERLAY */}
        <div className="hero-overlay-shadow"></div>

        {/* ✅ CONTENT */}
        <div className="hero-content">
          <div className="text-wrapper">
            <span className="hero-subtitle">Premium Travel & Rentals</span>

            <h1 className="hero-title">
              Explore & Drive <br />
              <span>Your Journey 🚗</span>
            </h1>

            <p className="hero-description">
              Experience luxury Tour Packages, reliable Self Drive Cars, 
              and professional Taxi Services—all in one place.
            </p>

            <div className="hero-action-area">
              <button
                className="btn-outline"
                onClick={() => navigate("/selfdrive")}
              >
                View Cars
              </button>
            </div>
          </div>
        </div>

        {/* ✅ SCROLL INDICATOR */}
        <div className="scroll-indicator">
          <div className="mouse">
            <div className="wheel"></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Background;